import { z } from "zod";

export const ReminderSchema = z.object({
  reminderId: z.string(),
  reminderTitle: z.string(),
  reminderText: z.string(),
});

export const ProjectReminderSchema = z.object({
  projectReminderId: z.string(),
  projectId: z.string(),
  ordinal: z.number(),
  enabled: z.boolean(),
  drawNumber: z.number(),
  percentCompleteLineItem: z.number(),
  lineItem: z.string(),
  reminderDate: z.coerce.date().nullable(),
  percentCompleteSite: z.number(),
  percentDrawnBudget: z.number(),
  privateReminder: z.boolean(),
  percentSite: z.number(),
  completedDate: z.coerce.date().nullable(),
  reminder: ReminderSchema,
  passed: z.boolean(),
});

export const ReminderListSchema = z.array(ReminderSchema);

export const ProjectReminderListSchema = z.array(ProjectReminderSchema);

export const TodaysRemindersSchema = z.object({
  currentReminders: ProjectReminderListSchema,
  upcomingReminders: ProjectReminderListSchema,
});

export type Reminder = z.infer<typeof ReminderSchema>;
export type ProjectReminder = z.infer<typeof ProjectReminderSchema>;
export type TodaysReminders = z.infer<typeof TodaysRemindersSchema>;
